import { render } from "./Forgotpassword.vue?vue&type=template&id=5cb56152&scoped=true"
import script from "./Forgotpassword.vue?vue&type=script&lang=js"
export * from "./Forgotpassword.vue?vue&type=script&lang=js"

import "./Forgotpassword.vue?vue&type=style&index=0&id=5cb56152&lang=scss&scoped=true"

import exportComponent from "D:\\project\\AIWOBU\\admin-love\\lovestory\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb56152"]])

export default __exports__